var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.822 19.175a9.8 9.8 0 0 1-2.073-3.06A9 9 0 0 1 2 12.525q0-1.854.705-3.663.705-1.81 2.293-3.399Q6.762 3.697 9.98 2.785t8.332-.765q.765.03 1.411.324t1.146.795a3.83 3.83 0 0 1 1.117 2.589 38 38 0 0 1-.132 4.458q-.19 2.044-.617 3.693-.426 1.647-1.088 2.928a8.8 8.8 0 0 1-1.572 2.192q-1.558 1.56-3.307 2.28A9.3 9.3 0 0 1 11.7 22a9.7 9.7 0 0 1-3.734-.75 9.5 9.5 0 0 1-3.144-2.075m3.291-.47a6.5 6.5 0 0 0 1.75.72q.896.22 1.836.221 1.353 0 2.675-.544 1.322-.545 2.527-1.751.529-.53 1.073-1.486.544-.957.94-2.501.398-1.545.603-3.737.206-2.193.06-5.223-1.441-.06-3.249-.044-1.807.015-3.6.28a17.4 17.4 0 0 0-3.41.853Q7.702 6.08 6.673 7.11 5.35 8.436 4.851 9.73t-.5 2.5q0 1.737.662 3.046.66 1.31 1.16 1.84 1.236-2.355 3.263-4.517a17.1 17.1 0 0 1 4.732-3.546 21.5 21.5 0 0 0-3.689 4.193q-1.572 2.34-2.366 5.458"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.ad459b968ca123f13195bb2021dbcd93.svg";
export { ForwardRef as ReactComponent };